import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

import { MAX_PAGE_HEIGHT } from '../../../../styles/constants';

export const useStyles = makeStyles<Theme>()((theme) => ({
  resetPasswordWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: MAX_PAGE_HEIGHT,
  },
  resetPasswordContentWrapper: {
    ...theme.mixins.appContainer,
    width: '480px',
    padding: theme.spacing(4, 2),

    [theme.breakpoints.down('md')]: {
      width: '100%',
      height: '100%',
      borderRadius: 0,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    },
  },
  resetPasswordForm: {
    width: '100%',
  },

  backToLogin: {
    textAlign: 'center',
    width: '100%',
    marginTop: '24px',
    fontWeight: 400,
    fontSize: '16px',
    color: theme.palette.font.secondary,
  },
  resetPasswordSubmitButton: {
    marginTop: '32px',
  },
  backToLoginButton: {
    cursor: 'pointer',
    color: theme.palette.primary.main,
    marginLeft: '4px',
  },
  textField: {
    '&:not(:first-of-type)': {
      marginTop: '16px',
    },
  },
}));
